// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ContentWrapper from 'Component/ContentWrapper';
import ProductList from 'Component/ProductList';
import TextPlaceholder from 'Component/TextPlaceholder';
import Html from 'Component/Html';
import Link from 'Component/Link';
import Image from 'Component/Image';
import ProductLinks from 'Component/ProductLinks';
import { RELATED } from 'Store/LinkedProducts/LinkedProducts.reducer';

import './SpecialOffer.style';

export class SpecialOffer extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    sliderConfig() {
        const sliderOptions = {
            additionalClass: 'ProductLinks-Slider',
            isSlider: true,
            sliderDots: true,
            sliderNavigation: true,
            sliderAutoplay: false,
            sliderInfinityScroll: false,
            productDisplayDesktop: 5,
            productDisplayTable: 3,
            productDisplayMobile: 2,
            productScrollDesktop: 5,
            productScrollTable: 3,
            productScrollMobile: 2
        }

        return sliderOptions;
    }

    /**
     * Renders the featured image
     * @returns {*}
     */
    renderImage() {
        const {post: {first_image, media_gallery, post_id}} = this.props;

        let imageUrl = first_image;

        if(media_gallery) {
            const mediaGalleryArray = media_gallery.split(';');

            if(mediaGalleryArray[0]){
                imageUrl = media(mediaGalleryArray[0]);
            }
        }

        if (!first_image && post_id) {
            return null;
        }

        return (
            <div
                block="PostsDetails"
                elem="MainImage"
            >
                <Image
                    block="PostsDetails"
                    elem="Image"
                    src={imageUrl}
                />
            </div>
        );
    }

    renderDescription() {
        const {post: {content}} = this.props;

        if (!content) {
            return (
                <TextPlaceholder
                    mix={{block: 'PostsDetails', elem: 'DescriptionPlaceholder'}}
                    length="custom"
                />
            );
        }

        return (
            <div mix={{block: 'PostsDetails', elem: 'Description'}}>
                <Html content={content}/>
            </div>

        );
    }

    renderContent() {
        const {post: {title}} = this.props;

        return (
            <div block="PostsDetails" elem="Content">
                <h1 mix={{block: 'PostsDetails', elem: 'Title'}}>
                    <TextPlaceholder length="medium" content={title}/>
                </h1>
                { this.renderDescription() }
                {this.renderSeeAllCTA()}
            </div>
        );
    }

    renderSeeAllCTA(){
        const { post : { list_type_category_url = '' } } = this.props;


        if(!list_type_category_url)
            return null;

        return (
            <div className="PostsDetails-Description">
                <p>
                    <Link to={ list_type_category_url.replace(window.location.origin,'') } className={'SpecialOffer-button'}>
                        { __('SEE ALL PRODUCTS') }
                    </Link>
                </p>
                <p className="note">
                    { __('*Τhe offer is valid for selected products and while stocks last. ') }
                    <br/>
                    { __('*Indicative offers, their final configuration is left to each store.') }
                </p>
            </div>
        );
    }

    renderRelatedSection(){
        const { pages, device, post : { list_type } } = this.props;
        return (
            <section aria-label="Special Offer Products">
                {
                    list_type ?
                        <>
                            <h2 className="ProductLinks-Title"><span>{ __('RELATED PRODUCTS') }</span></h2>
                            {
                            Object.keys(pages).length ?
                                    <ProductList
                                        pages={pages}
                                        isSlider={true}
                                        sliderOptions={this.sliderConfig()}
                                        slick_slider_class="ProductLinks-Slider"
                                    />
                                :
                                null
                            }
                        </>
                        :
                        <ProductLinks
                            linkType={ RELATED }
                            title={ __('RELATED PRODUCTS') }
                            numberOfProductsToDisplay={10}
                            isBlogRelated={true}
                        />
                }
            </section>
        );
    }


    render() {
        return (
            <main block="PostsDetails" className="SpecialOffer">
                <ContentWrapper
                    wrapperMix={{block: 'PostsDetails', elem: 'Wrapper'}}
                    label="Post"
                >
                    <div block="PostsDetails" elem="ColumnWrapper">
                        <div block="PostsDetails" elem="Top">
                            {this.renderImage()}
                            {this.renderContent()}
                        </div>
                        {this.renderRelatedSection()}
                    </div>
                </ContentWrapper>
            </main>
        );
    }
}

export default SpecialOffer;
